export const DEPOSIT_PAGE = 'd3704cb0-e113-460c-9aa9-354819347cc7'
